import React from 'react'

import { ColumnRank, ColumnStartOrder, ColumnResult, ColumnName, ColumnNoc, ColumnQualification, ColumnExpander } from "components/common/TableColumns"
import Label from "components/general/Label"
import { findArray } from 'helpers/utils'

export function ColumnAfterRound({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-10',
    label = 'LabelAfterRound',
}) {

    return (
        {
            Header: <Label data={label} />,
            sortType: "absoluteOrderNumber",
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'AfterRound',
            Cell: (props) => {
                let row = props.cell.row.original
                let val = findArray(row.extendedResults, { er_code: ['COMPLETE'] })?.er_value
                return (val)
            },


        }
    )
}

export function TableColumnsLive() {
    return (
        [
            ColumnRank({ hasIrm: false }),
            ColumnStartOrder({}),
            ColumnNoc({}),
            ColumnName({}),
            ColumnAfterRound({}),
            ColumnResult({ label: "HeaderTotalPoints" }),
            ColumnQualification({}),
            ColumnExpander({ type: 'alwaysTrue' })
        ]
    )
}

export function TableColumnsLiveSM() {
    return (
        [
            ColumnRank({ hasIrm: false }),
            ColumnStartOrder({}),
            ColumnNoc({}),
            ColumnName({}),
            ColumnAfterRound({}),
            ColumnResult({ label: "HeaderTotalPoints" }),
            ColumnQualification({}),
            ColumnExpander({ type: 'alwaysTrue' })
        ]
    )
}

export function TableColumnsFinish() {

    return (
        [
            ColumnRank({ hasIrm: false }),
            ColumnNoc({}),
            ColumnName({}),
            ColumnResult({ label: "HeaderTotalPoints" }),
            ColumnQualification({}),
            ColumnExpander({ type: 'alwaysTrue' })
        ]
    )
}

export function TableColumnsFinishSM() {

    return (
        [
            ColumnRank({ hasIrm: false }),
            ColumnNoc({}),
            ColumnName({}),
            ColumnResult({ label: "HeaderTotalPoints" }),
            ColumnQualification({}),
            ColumnExpander({ type: 'alwaysTrue' })
        ]
    )
}